export enum ValidationType {
    none = 0,
    regex = 1,
    cpr = 2,
    cvr = 3,
    cardNumber = 4,
    driverLicenseDk = 5,
    textNoSpaces = 6,
    textWithSpaces = 7,
    commaSeparatedList = 8,
    autorisationsNr = 9,
    amountOfCards = 10,
    driverLicenseInt = 11,
    textWithSpacesMax35 = 12,
    textWithSpacesAndNumbers = 13,
    textWithSpacesAndNumbersMax35 = 14,
    wrxNr = 15,
}